import { Paper, styled } from '@mui/material';

export const StyledLessonsLinkItemWrap = styled(Paper)({
	padding: '8px 16px',
	display: 'flex',
	gap: '8px',
	alignItems: 'center',
	justifyContent: 'space-between',
	borderRadius: '10px',
});
